module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/20ft-mobile-37a3fff099ca2499e4d3a91df2373b69.png";